// This file includes polyfills needed by Angular and is loaded before the app.
// You can add your own extra polyfills to this file.
import 'core-js/stable/symbol';
import 'core-js/stable/object';
import 'core-js/stable/function';
import 'core-js/stable/parse-int';
import 'core-js/stable/parse-float';
import 'core-js/stable/number';
import 'core-js/stable/math';
import 'core-js/stable/string';
import 'core-js/stable/date';
import 'core-js/stable/array';
import 'core-js/stable/regexp';
import 'core-js/stable/map';
import 'core-js/stable/set';
import 'core-js/stable/reflect';
import 'core-js/proposals/reflect-metadata';

import 'core-js/stable/promise';
import 'zone.js/dist/zone';

// If you need to support the browsers/features below, uncomment the import
// and run `npm install import-name-here';
// Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html

// Needed for: IE9
import 'classlist.js';

// Animations
// Needed for: All but Chrome and Firefox, Not supported in IE9
// import 'web-animations-js';

// Date, currency, decimal and percent pipes
// Needed for: All but Chrome, Firefox, Edge, IE11 and Safari 10
// import 'intl';
// import 'intl/locale-data/jsonp/en.js';

// NgClass on SVG elements
// Needed for: IE10, IE11
// import 'classlist.js';

// Needed for the FontAwesome module, which is a dependency
// of ngx-sharebuttons used in ShareButtonsComponent
// https://murhafsousli.github.io/ngx-sharebuttons/#/icons
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons';

const icons = [
  faFacebookF,
  faTwitter,
];

export function initializeFabIcons(library: FaIconLibrary) {
  return () => {
    library.addIcons(...icons);
  };
}

